import { jsx as h } from "react/jsx-runtime";
import { QUERIES as c } from "@fcamna/shared-component-foundations";
import { useRef as $ } from "react";
import r from "styled-components";
import { u as x } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { u as W } from "./uniqueId-321287e8.mjs";
const a = (e) => {
  switch (e) {
    case 1:
    case 2:
    case 4:
    case 5:
    case 7:
    case 8:
    case 10:
    case 11:
      return 8.33 * e + "%";
    case 3:
      return "25%";
    case 6:
      return "50%";
    case 9:
      return "75%";
    default:
      return "100%";
  }
}, w = r.div`
  ${(e) => {
  var t, i, d;
  return `
    width: ${(t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.grid.MainWrapper.width};
    height: ${(i = e == null ? void 0 : e.theme) == null ? void 0 : i.components.grid.MainWrapper.height};
    overflow: ${(d = e == null ? void 0 : e.theme) == null ? void 0 : d.components.grid.MainWrapper.overflow};
  `;
}};
`, G = r.div`
  ${(e) => {
  var t, i, d, n, m;
  return `
  width: calc(${(t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.grid.GridWrapper.width} + ${e.$gutterWidth}px);
  display: ${(i = e == null ? void 0 : e.theme) == null ? void 0 : i.components.grid.GridWrapper.display};
  flex-wrap: ${(d = e == null ? void 0 : e.theme) == null ? void 0 : d.components.grid.GridWrapper.flexWrap};
  height: ${(n = e == null ? void 0 : e.theme) == null ? void 0 : n.components.grid.GridWrapper.height};
  box-sizing: ${(m = e == null ? void 0 : e.theme) == null ? void 0 : m.components.grid.GridWrapper.boxSizing};
  --gutter-width: ${e.$gutterWidth}px;
  row-gap: ${e.$rowGap}px;
  `;
}}
`, f = r.div`
  ${(e) => {
  var t, i, d, n, m;
  return `
    width: ${(t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.grid.FlexGridWrapper.width};
    min-width: ${(i = e == null ? void 0 : e.theme) == null ? void 0 : i.components.grid.FlexGridWrapper.minWidth};
    flex-grow: ${(d = e == null ? void 0 : e.theme) == null ? void 0 : d.components.grid.FlexGridWrapper.flexGrow};
    height: ${(n = e == null ? void 0 : e.theme) == null ? void 0 : n.components.grid.FlexGridWrapper.height};
    box-sizing: ${(m = e == null ? void 0 : e.theme) == null ? void 0 : m.components.grid.FlexGridWrapper.boxSizing};
    padding-right: var(--gutter-width);
  `;
}}
`, I = r.div`
  ${(e) => {
  var t, i;
  return `
    width: ${a(e == null ? void 0 : e.$s)};
    height: ${(t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.grid.GridItemWrapper.height};
    box-sizing: ${(i = e == null ? void 0 : e.theme) == null ? void 0 : i.components.grid.GridItemWrapper.boxSizing};
    padding-right: var(--gutter-width);

    @media ${c.tabletAndUp} {
      width: ${a(e.$m)};
    }
    @media ${c.laptopAndUp} {
      width: ${a(e.$l)};
    }
    @media ${c.desktopAndUp} {
      width: ${a(e.$xl)};
    }
  `;
}}
`, l = ({ children: e, gutterWidth: t = 12, style: i = {}, className: d = "", rowGap: n = 8 }) => {
  const m = x({ label: "Grid" }), g = $(null), u = $(W("grid"));
  return /* @__PURE__ */ h(w, { ...m, children: /* @__PURE__ */ h(
    G,
    {
      id: u.current,
      ref: g,
      $gutterWidth: t,
      style: i,
      className: d,
      $rowGap: n,
      children: e
    }
  ) });
}, b = ({ s: e = 12, m: t = 6, l: i = 4, xl: d = 3, children: n, style: m = {}, className: g = "" }) => /* @__PURE__ */ h(
  I,
  {
    $s: e,
    $m: t,
    $l: i,
    $xl: d,
    style: m,
    className: `grid-item ${g}`,
    children: n
  }
), v = ({ className: e, style: t, children: i }) => /* @__PURE__ */ h(
  f,
  {
    className: `grid-item ${e}`,
    style: t,
    children: i
  }
);
l.Item = b;
l.FlexItem = v;
export {
  l as Grid
};
